import React, {FC} from 'react';

import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import LogoutIcon from '@mui/icons-material/Logout';
import Box from '@mui/material/Box';

import {useTranslation} from 'react-i18next';

const styles = {
  container: {
    position: 'absolute',
    top: 8,
    right: 8,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: 1000
  }
};

type LogoutProps = {
  onLogout: () => void
}

const Logout: FC<LogoutProps> = ({onLogout}) => {

  const {t} = useTranslation();

  return <Box sx={styles.container} onClick={onLogout}>
    <Typography>{t('authentication.logout')}</Typography>
    <IconButton>
      <LogoutIcon/>
    </IconButton>
  </Box>;
};
export default Logout;